import React, { useState, useEffect, useContext } from "react";
import { withRouter } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import AppConstants from '../../common/AppConstants';
import Container from '@material-ui/core/Container';
import CircularLoader from '../../sharedComponents/emptyStateUIContainers/CircularLoader';


const useStyles = makeStyles(theme => ({
    
    SignupComponent: {
        maxWidth: '600px !important',
        background: '#000 !important',
        minWidth: 'unset !important',
        boxShadow: "0px 0px 5px rgb(255 255 255 / 30%)  !important",
        '& .uwStyleDialogCloseButton': {
            color: '#888888 !important',
            background: 'transparent',
            '&:hover, &:focus': {
                background: 'transparent',
            },
        },
        '& .uwTextControlStyle': {
            '&:disabled': {
                color: '#888888 !important',
            },
        },
        '& .header': {
            color: '#888888 !important',          
        },
    },

    signupBtn: {
        color: "#000",
        backgroundColor: "#fff !important",
        cursor: "pointer",
        padding: theme.spacing(1, 2),
        // margin: theme.spacing(.5),
        lineHeight: "1.75",
        borderRadius: "4px",
        letterSpacing: "0.02857em",
        border: "0",
        width: "100%",
        textTransform: 'uppercase',
    },
    
    SignInContent:{
        color: "#000",
        backgroundColor: "#fff !important",
    },
    
    SignUpSubContent: {
        margin: theme.spacing(-1),
        '& > div': {
            padding: theme.spacing(1),
            color: '#888888 !important',
            '& .uvLoginLink': {
                color: '#888888 !important',
                '&:hover, &:focus': {
                    color: '#888888 !important',
                },
            },
            '& .subheader': {
                color: '#888888 !important',
                '&:hover, &:focus': {
                    color: '#888888 !important',
                },
            },
            '& .uwsignupAccount': {
                color: '#888888 !important',
                '&:hover, &:focus': {
                    color: '#888888 !important',
                },
            }        
        }
    },

    signin: {
        boxShadow: "0px 0px 5px rgb(255 255 255 / 30%)  !important",
        border: '2px solid #b5b5b5',
        '& .header': {
            color: '#888888 !important',          
        },
        '& .uwCheckBoxContainerStyle': {
            color: '#888888 !important',   
            '& a, & a:hover, & a:focus': {
                color: '#888888 !important',   
            },       
        },
        '& .uwCheckMarkStyle': {
            background: 'transparent !important', 
            border: '1px solid #b5b5b5',         
        },       
        '& .uwStyleDialogCloseButton': {
            color: '#888888 !important',
            background: 'transparent',
            '&:hover, &:focus': {
                background: 'transparent',
            },
        },
        '& .uwTextControlStyle': {
            '&:disabled': {
                color: '#888888 !important',
            },
        }
    },
    
    signinBox: {
        height: 'auto',
        '& > div': {
            background: 'rgba(0, 0, 0, .6)',
            height: '100%',
            padding: theme.spacing(3),
            '& .header': {
                color: 'rgba(255, 255, 255, .54)',
            },
        },
    }

}));


const Signin = (props) => {
    const classes = useStyles();
    const [Loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);
        scriptLoaded();       
    }, []);

    const scriptLoaded = () => {
        setTimeout(function(){ 
            const mylib = window.UVWidget;
            const myWidget = window.UVWidget.Login.new({
                modal: AppConstants.MODEL,
                apiKey: AppConstants.WIDGET_API_KEY,
                appId: AppConstants.WIDGET_API_ID,
                env: AppConstants.WIDGET_ENV,
                selector: 'divSignIn',
                //redirectUrl: AppConstants.QA_URL,
                cssStyle: {
                    SignUp: {
                        styleComponent: classes.SignupComponent,
                        styleDialogCloseButton: 'uvLoginCloseButton',
                        styleButton: classes.signupBtn,
                        styleSubContent: classes.SignUpSubContent,
                        styleDropDown: classes.styleDropDownCls
                    },
                    LogIn: {
                        styleComponent: classes.SignupComponent,
                        styleImage: 'uvLoginImage',
                        styleDialogCloseButton: 'uvLoginCloseButton',
                        styleLink: 'uvLoginLink',
                        styleButton: classes.signupBtn,
                        styleSubContent: classes.SignUpSubContent
                    },
                    ForgotPassword: {
                        styleComponent: classes.SignupComponent,
                        styleDialogCloseButton: 'uvLoginCloseButton',
                        styleButton: classes.signupBtn
                    }
                }
            });
            myWidget.Show();
            setLoading(false);
            myWidget.On("onLoginSuccess", function (response) {
               // console.log("onLoginSuccess", response)
                if (response !== undefined && response.status !== undefined) {
                    // setUserLoggedin(true);
                    // setUserFirstName(response.data.userDetails.firstName);
                    // setUserLastName(response.data.userDetails.lastName);
                    localStorage.setItem("UserToken", response.data.token);
                    localStorage.setItem("UserResetToken", response.data.resetToken);
                    localStorage.setItem("UserDetail", JSON.stringify(response.data.userDetails));
                    props.history.push("/");
                }
            });
            myWidget.On("onLoginFailure", function (response) {
                // console.log("onLoginFailure",response)
            })
        }, 3000); 
    };

    return (
        <>
        {Loading && <CircularLoader />}
        <Container maxWidth="sm" className={classes.signinBox}>
            <div id="divSignIn" className={classes.signin}></div>
        </Container>
        </>
    )
}
export default withRouter(Signin);